import React, { useEffect, useState } from "react";
import "./index.css";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import patientAvatar from "../avatar.png";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import { Link, useNavigate, useParams } from "react-router-dom";
import StarRatings from "react-star-ratings";
import axios from "axios";
import { authHeader } from "auth/authHeader";
import moment from "moment-timezone";

const Thankyou = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
    const [convertedTime, setConvertedTime] = useState("");
    const [convertedDate, setConvertedDate] = useState("");
    const [localTZ, setLocalTZ] = useState(
      localStorage.getItem("Time-Zone") || moment.tz.guess() || "UTC"
    )
  const params = useParams();
  const loadDetails = () => {
    // setLoading(true);
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}appointment/${params.id}`, {
        headers: authHeader(),
      })
      .then(function (response) {
        setData(response.data.data?.[0]);
      })
      .catch((error) => {
        // JSON.stringify(error);
        console.log(error);
        // setError("Invalid Credentials");
      })
      .finally(() => {
        // setLoading(false);
      });
  };

  useEffect(() => {
    loadDetails();
  }, []);

  //  console.log("convertedTime : " + convertedTime);
  //  console.log("convertedDate : " + convertedDate);
  //  console.log("formattedTime : " + formattedTime);
  //  console.log("formattedDate : " + formattedDate);
  //  console.log("selectedSlot : " + selectedSlot);
  //  console.log("selectedDate : " + selectedDate);
  //  console.log("patientTimeZone : " + patientTimeZone);
useEffect(() => {
  if (data && data.date && data.slotTime) {
    const utcTime = `${data.date} ${data.slotTime}`;
    const patientTimeZone = localTZ;
      // Automatically detect patient's timezone

    const formattedTime = moment
      .utc(data.slotTime)
      .tz(patientTimeZone)
      .format("HH:mm A");

    const formattedDate = moment
      .utc(data.date) 
      .tz(patientTimeZone)
      .format("MMMM Do, YYYY");

    setConvertedTime(formattedTime);
    setConvertedDate(formattedDate);
  }
}, [data]);

  return (
    <>
      <div className="addAppointmentMain">
        <div className="addAppointmentMainHeading">
          <div onClick={() => navigate(-1)}>
            <ArrowCircleLeftOutlinedIcon
              className="headingIcon"
              fontSize="large"
            />
          </div>
          <h3>Add Appointment</h3>
        </div>
        <div>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              "& > :not(style)": {
                ml: 2,
                mr: 4,
                pl: 4,
                pb: 2,
                pr: 4,
                width: "100%",
                height: "auto",
                background:
                  "linear-gradient(90.22deg, #0536E3 -19.45%, #00E9ED 142.36%)",
                color: "#ffffff",
              },
            }}
          >
            <Paper elevation={0}>
              <Grid container>
                <Grid item lg={7} md={6} xs={12}>
                  <Stack direction="row" spacing={2}>
                    {/* <Avatar alt="Patient Avatar" src={patientAvatar} className='addAppointmentProfileAvatar' /> */}
                    <div className="addAppointmentProfileAvatarName">
                      <h2>{data?.Doctor?.name}</h2>
                      <p>
                        {/* Specialist{" "} */}
                        {data?.Doctor?.serviceCategories?.map((e, i) => {
                          if (i == 0) return e;
                          else return e + " |";
                        })}
                      </p>
                      <div>
                        {/* <StarRatings
                          rating={4}
                          starDimension="18px"
                          starRatedColor="yellow"
                          numberOfStars={5}
                          starSpacing="1px"
                        /> */}
                      </div>
                    </div>
                  </Stack>
                </Grid>
                <Grid
                  item
                  lg={5}
                  md={6}
                  xs={12}
                  mt={-3}
                  className="appointmentPriceGrid"
                >
                  <p>{`LKR${data?.Doctor?.displayingFee}.00`}</p>
                </Grid>
              </Grid>
            </Paper>
          </Box>
        </div>

        <div className="docterProfileScroll">
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              "& > :not(style)": {
                ml: 2,
                mr: 2,
                pl: 4,
                pb: 2,
                pr: 4,
                width: "100%",
                height: 480,
              },
            }}
          >
            <Paper elevation={0} className="thankyouPaper">
              <div className="thankyouDiv">
                <img
                  alt="tick icon"
                  src="https://cdn.pixabay.com/photo/2014/04/03/10/41/hand-311121_960_720.png"
                  width={50}
                  height={50}
                ></img>
                <h2>Thank You !</h2>
                <p>Your Appointment Successful</p>
                <p>
                  You Booked an appointment with Dr. {data?.Doctor?.name} on {''}
                  {/* {data?.date} at {data?.slotTime} */}
                  {convertedDate} at {convertedTime} in {localTZ}
                </p>
                <Link to="/appointments" className="patientLink">
                  <Button variant="contained" className="payBtn">
                    View Your Appointment
                  </Button>
                </Link>
              </div>
            </Paper>
          </Box>
        </div>
      </div>
    </>
  );
};
export default Thankyou;
